export function getNetworkNameFromFQDN(fqdn) {
    var parts = fqdn.split('.');
    return parts.slice(1).join('.');
}
